import React from 'react';
// styles
import styled, { css } from 'styled-components';
// state
import { useSoFormStepsState } from '../../SoForm.context';
import SoFormStepCard from '../../steps/card/SoFormStepCard';
import SoFormStepCardBody from '../../steps/card/SoFormStepCardBody';
import SoFormStepComplements from '../../steps/complements/SoFormStepComplements';
import SoFormStepComplementsBody from '../../steps/complements/SoFormStepComplementsBody';
import SoFormStepConfiguration from '../../steps/configuration/SoFormStepConfiguration';
import SoFormStepConfigurationBody from '../../steps/configuration/SoFormStepConfigurationBody';
import SoFormStepConfirmation from '../../steps/confirmation/SoFormStepConfirmation';
import SoFormStepConfirmationBody from '../../steps/confirmation/SoFormStepConfirmationBody';
import SoFormStepPrice from '../../steps/price/SoFormStepPrice';
import SoFormStepPriceBody from '../../steps/price/SoFormStepPriceBody';
import SoFormStepSuccess from '../../steps/success/SoFormStepSuccess';
import SoFormStepSuccessBody from '../../steps/success/SoFormStepSuccessBody';
import * as Sentry from '@sentry/react';
import { captureCatalogError } from 'sentry';
import SoFormStepPayment from '../../steps/payment/SoFormStepPayment';
import SoFormStepPaymentBody from '../../steps/payment/SoFormStepPaymentBody';

const SoFormBody = ({ className }) => {
  const stepsState = useSoFormStepsState();
  const currentStep = stepsState.currentStep;
  const step_name = currentStep.nameForData;
  const onError = (e) => {
    captureCatalogError({
      e,
      step_name: step_name,
      error_type: 'LOGIC',
      action_name: 'SoFormBody errorBoundary',
    });
  };
  return (
    <div className={className}>
      <Sentry.ErrorBoundary onError={onError}>
        {currentStep.nameForData === SoFormStepConfiguration.nameForData && (
          <SoFormStepConfigurationBody />
        )}
        {currentStep.nameForData === SoFormStepPrice.nameForData && (
          <SoFormStepPriceBody />
        )}
        {currentStep.nameForData === SoFormStepComplements.nameForData && (
          <SoFormStepComplementsBody />
        )}
        {currentStep.nameForData === SoFormStepConfirmation.nameForData && (
          <SoFormStepConfirmationBody />
        )}
        {currentStep.nameForData === SoFormStepSuccess.nameForData && (
          <SoFormStepSuccessBody />
        )}
        {currentStep.nameForData === SoFormStepCard.nameForData && (
          <SoFormStepCardBody />
        )}
        {currentStep.nameForData === SoFormStepPayment.nameForData && (
          <SoFormStepPaymentBody />
        )}
      </Sentry.ErrorBoundary>
    </div>
  );
};

const regularCSS = css`
  background: var(--grey100);
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  overflow: auto;
  flex: 1;
`;

export default styled(SoFormBody)`
  ${regularCSS}
`;
